// In HomePage.js
import React from 'react';

function ProgramsPage() {
  return (
    <div>
      <h1> Programs page test</h1>
      // ... other content
    </div>
  );
}

export default ProgramsPage;